import { useContext } from 'react';
import { useWatch } from 'react-hook-form';

import { CAMPAIGN_DTO_ENUMS } from 'api/repositories/campaign/campaign.constants';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { FashionCampaignFormStepTwoContextProvider } from './fashionCampaignFormStepTwo.context';
import OutputTypeField from './components/formFields/outputTypeField/outputTypeField';
import PhotoForm from './components/photoForm/photoForm';
import ReelsForm from './components/reelsForm/reelsForm';

const FashionCampaignFormStepTwo = () => {
  const { brand, campaignFormMethods } = useContext(CampaignFormContext);

  const outputTypeFl = useWatch({
    control: campaignFormMethods.control,
    name: 'outputTypeFl',
  });

  return (
    <>
      <div className="flex flex-col gap-16">
        {!brand.isWholesale && (
          <div className="mt-8">
            <OutputTypeField />
          </div>
        )}

        <div className="flex flex-col">
          <FashionCampaignFormStepTwoContextProvider>
            {outputTypeFl === CAMPAIGN_DTO_ENUMS.OUTPUT_TYPE_FL.PHOTO ? (
              <PhotoForm />
            ) : (
              <ReelsForm />
            )}
          </FashionCampaignFormStepTwoContextProvider>
        </div>
      </div>
    </>
  );
};

export default FashionCampaignFormStepTwo;
